import { Component } from '@angular/core';

@Component({
  selector: 'app-warning-price-chance-modal',
  templateUrl: './warning-price-chance-modal.component.html',
  styleUrls: ['./warning-price-chance-modal.component.scss']
})
export class WarningPriceChanceModalComponent {

  visible = false;

  open() {
    this.visible = true;
  }

  reload() {
    location.reload();
  }
}
